import type { LenderYields } from '../types'

export function getIntrinsicYieldOpen(
  amountInUSD: number,
  amountOutUSD: number,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn = amountInUSD * yieldIn.intrinsicYield
  const _flowOut = amountOutUSD * yieldOut.intrinsicYield
  const totalCashFlowDebt = cashFlowDebt + _flowIn
  const totalCashFlowDeposits = cashFlowDeposits + _flowOut
  const newCollat = deposits + amountOutUSD
  const newDebt = debt + amountInUSD
  return [
    totalCashFlowDebt / newDebt,
    totalCashFlowDeposits / newCollat,
    (totalCashFlowDeposits - totalCashFlowDebt) / (newCollat - newDebt),
  ]
}

export function getIntrinsicYieldClose(
  amountInUSD: number,
  amountOutUSD: number,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn = amountInUSD * yieldIn.intrinsicYield
  const _flowOut = amountOutUSD * yieldOut.intrinsicYield
  const totalCashFlowDebt = cashFlowDebt - _flowOut
  const totalCashFlowDeposits = cashFlowDeposits - _flowIn
  const newCollat = deposits - amountInUSD
  const newDebt = debt - amountOutUSD
  return [
    Math.abs(newDebt) < 0.01 ? 0 : totalCashFlowDebt / newDebt,
    totalCashFlowDeposits / newCollat,
    (totalCashFlowDeposits - totalCashFlowDebt) / (newCollat - newDebt),
  ]
}

export function getIntrinsicYieldDebtSwap(
  amountInUSD: number,
  amountOutUSD: number,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn = amountInUSD * yieldIn.intrinsicYield
  const _flowOut = amountOutUSD * yieldOut.intrinsicYield
  const totalCashFlowDebt = cashFlowDebt + _flowIn - _flowOut
  const newDebt = debt - amountOutUSD + amountInUSD
  return [
    Math.abs(newDebt) < 0.01 ? 0 : totalCashFlowDebt / newDebt,
    cashFlowDeposits / deposits,
    (cashFlowDeposits - totalCashFlowDebt) / (deposits - newDebt),
  ]
}

export function getIntrinsicYieldCollateralSwap(
  amountInUSD: number,
  amountOutUSD: number,
  cashFlowDeposits: number,
  cashFlowDebt: number,
  deposits: number,
  debt: number,
  yieldIn: LenderYields,
  yieldOut: LenderYields
): [borrowApr: number, depositApr: number, apr: number] {
  const _flowIn = amountInUSD * yieldIn.intrinsicYield
  const _flowOut = amountOutUSD * yieldOut.intrinsicYield
  const totalCashFlowDeposits = cashFlowDeposits + _flowOut - _flowIn
  const newCollat = deposits + amountOutUSD - amountInUSD
  return [
    Math.abs(debt) < 0.01 ? 0 : cashFlowDebt / debt,
    totalCashFlowDeposits / newCollat,
    (totalCashFlowDeposits - cashFlowDebt) / (newCollat - debt),
  ]
}
